<template>
  <b-modal
    centered
    size="md"
    :visible="show"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container fluid>
      <b-row>
        <b-col>
          <h4 class="text-info m-2">{{ order_item_name }}:</h4>
          <h5 class="text-secondary m-2">
            {{
              $t("globals.change_quantity_from") + ": " + order_item_quantity
            }}
          </h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label class="m-2">{{ $t("globals.new_quantity") }}:</label>
        </b-col>
        <b-col>
          <b-row class="align-items-center">
            <b-col cols="2">
              <button @click="setNewQuantity(-1)" class="btn" :class="button_class">-</button>
            </b-col>
            <b-col cols="4">
              <b-input
                class="m-2"
                :class="border_class"
                v-model.number="new_order_item_quantity"
                type="text"
                readonly
              ></b-input>
            </b-col>
            <b-col cols="2">
              <button @click="setNewQuantity(1)" class="btn" :class="button_class">+</button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      
      <hr />
        <strong v-if="movement_type !== null">

          <span v-if="movement_type === 'adding'">{{ $t("globals.you_are_adding") }}</span>
          <span v-if="movement_type === 'removing'">{{ $t("globals.you_are_removing") }}</span>
          
          {{ Math.abs(new_order_item_quantity - order_item_quantity) }}
          {{ $t("globals.devices") }}.
        </strong>
      <b-row>
        <b-col>
          <b-btn
            style="float: right; margin: 0.3em;"
            @click="save"
            variant="success"
            :disabled="saveDisabled"
          >
            {{ $t("globals.save") }}
          </b-btn>
          <b-btn
            style="float: left; margin: 0.3em;"
            @click="cancelModal"
            variant="warning"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    show: Boolean,
    close: Function,
    order_item_id: String,
    order_item_quantity: Number,
    order_item_name: String
  },
  data() {
    return {
      new_order_item_quantity: 0,
      border_class: "",
      button_class: " btn-outline-primary",
      movement_type: null
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    save() {
      let data = {
        query: `
          mutation { 
            res: OrderItemUpdateQuantity (
              order_item_id: ${parseInt(this.order_item_id)},
              new_quantity: ${parseInt(this.new_order_item_quantity)}
            )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.cancelModal();
      });
    },
    cancelModal() {
      this.new_order_item_quantity = null;
      this.close();
    },
    setNewQuantity(delta) {
      if (this.new_order_item_quantity + delta < 1) {
        this.new_order_item_quantity = 1;
        return;
      }
      
      this.new_order_item_quantity = this.new_order_item_quantity + delta;
      const percentChange = ((this.new_order_item_quantity - this.order_item_quantity) / this.order_item_quantity) * 100;
      const absPercentChange = Math.abs(percentChange)

      this.movement_type = this.new_order_item_quantity === this.order_item_quantity ? null : this.new_order_item_quantity > this.order_item_quantity ? "adding" : "removing"
      // define threshold based on current quantity
      let threshold
      if (this.order_item_quantity <= 2) {
        threshold = 500
      } else if (this.order_item_quantity <= 5) {
        threshold = 100
      } else if (this.order_item_quantity <= 10) {
        threshold = 50
      } else {
        threshold = 40
      }
      
      
      if (absPercentChange >= threshold && this.movement_type === "removing") {
        this.border_class = "border border-danger"   // very large change
        this.button_class = " btn-outline-danger"
      } else if (absPercentChange >= threshold / 2) {
        this.border_class = "border border-warning"  // moderate change
        this.button_class = " btn-outline-warning"
      } else if (absPercentChange >= threshold / 4) {
        this.border_class = "border border-info"     // small change
        this.button_class = " btn-outline-info"
      } else {
        this.border_class = "border border-secondary" // negligible change
        this.button_class = " btn-outline-primary"
      }
    }
  },
  computed: {
    saveDisabled: function() {
      return (
        this.new_order_item_quantity == null || this.new_order_item_quantity < 1
      );
    }
  },
  mounted() {
    this.new_order_item_quantity = this.order_item_quantity || 0;
  },
  watch: {
    show(newVal) {
      this.new_order_item_quantity = this.order_item_quantity || 0;
      this.button_class = " btn-outline-primary"
      this.border_class = ""
    }
  },
  
};
</script>
